export const datetimeConstants = {
  FORMAT: {
    DEFAULT: 'DD/MM/YYYY',
    BACK_END_DEFAULT: 'DD-MM-YYYY',
    FLATPICKR_DEFAULT: 'd/m/Y',
  },
  FLATPICKR: {
    DEFAULT_FORMAT: 'd/m/Y',
    SINGLE_MODE: 'single',
    TODAY: 'today',
  },
  MOMENT_RELATIVE_TIME: {
    future: 'in %s',
    past: '%s ago',
    s: 'few seconds',
    ss: '%d seconds',
    m: '1 minute',
    mm: '%d minutes',
    h: '1 hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    w: '1 week',
    ww: '%d weeks',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
};
